

import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
    useGetExcelChatProjectIdQuery
} from "../../../../features/conversationapiSlice";
import {ExcelListTable} from "../PlayWrightChatPage/ExcelListTable";
import QueryChatScreen from "../../../AIChatScreen/Rev1Chat/QueryChatScreen";

export default function ExcelProjectQueryDashboard() {

    const { id } = useParams<{ id: string }>();

    const {
        data: chatSession,
        isLoading,
        isError,
    } = useGetExcelChatProjectIdQuery(id!, {
        skip: !id,
    });

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        return <div>Unable to load Excel conversation.</div>;
    }

    return (
        <main>
            <h2>Excel Chat</h2>


        </main>
    );
}